export default {
    methods: {
        swhDestroy() {
            this.slider && this.slider.destroy();
        },
        swhCreate() {
            console.error('NO IMPLEMENTATION: "swhCreate" must be implemented to create the swiper instance', this.$el)
        },
        swhReload() {
            this.swhDestroy();

            this.swhCreate();

            this.$nextTick(() => {
                this.slider && this.slider.update();
            });
        }
    }
}